import { useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

export default function useMarketNotifications() {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchNotifications = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/market/notifications/`);
      setNotifications(res.data);
    } catch (e) { /* no profile */ }
  }, []);

  const fetchUnreadCount = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/market/notifications/count/`);
      setUnreadCount(res.data.count);
    } catch (e) { /* no profile */ }
  }, []);

  const markAllRead = useCallback(async () => {
    try {
      await axios.post(`${API}/market/notifications/read/`);
      setUnreadCount(0);
      setNotifications(prev => prev.map(n => ({ ...n, is_read: true })));
    } catch (e) { /* */ }
  }, []);

  return { notifications, unreadCount, fetchNotifications, fetchUnreadCount, markAllRead };
}
